<div class="content audit-review-page">
  <div class="container-fluid">
    <div class="audit-review-header">
      <div>
        <h1>Audit Review <span *ngIf="audit?.benefit_domain || audit?.benefitDomain" class="audit-case-domain">{{(audit.benefit_domain || audit.benefitDomain) === 'MEDICAL' ? 'Medical' : 'Dental'}}</span></h1>
        <p>Review patient verification and audit each configured question.</p>
      </div>

      <div class="audit-review-header-actions">
        <button type="button" class="audit-secondary-btn" (click)="loadTimeline()">
          <i class="fa-regular fa-clock"></i>
          Activity
        </button>
        <button type="button" class="audit-secondary-btn" (click)="loadRevisions()">
          <i class="fa-solid fa-code-branch"></i>
          Revisions
        </button>
      </div>
    </div>

    <div class="audit-review-loading" *ngIf="loading">
      <span class="spinner-border spinner-border-sm"></span>
      Loading audit...
    </div>

    <ng-container *ngIf="!loading">
      <div class="audit-summary-card">
        <div class="audit-patient-summary">
          <div class="audit-avatar">
            {{ patientName.substring(0, 2).toUpperCase() }}
          </div>
          <div>
            <div class="audit-patient-name">{{ patientName }}</div>
            <div class="audit-patient-meta">
              Patient ID: {{ audit.patient_id || '-' }}
              <span>•</span>
              Reference: {{ audit.patient_reference || '-' }}
              <span>•</span>
              DOB: {{ patientDob }}
            </div>
          </div>
        </div>

        <div class="audit-summary-item">
          <div class="audit-summary-icon"><i class="fa-regular fa-building"></i></div>
          <div>
            <span>Client</span>
            <strong>{{ clientName }}</strong>
          </div>
        </div>

        <div class="audit-summary-item">
          <div class="audit-summary-icon"><i class="fa-regular fa-file-lines"></i></div>
          <div>
            <span>Form Type</span>
            <strong>{{ audit.form_type || '-' }}</strong>
          </div>
        </div>

        <div class="audit-summary-item">
          <div class="audit-summary-icon"><i class="fa-regular fa-calendar"></i></div>
          <div>
            <span>Submitted On</span>
            <strong>{{ audit.submitted_at | date:'MM/dd/yyyy':'UTC' }}</strong>
            <small>{{ audit.submitted_at | date:'hh:mm a':'UTC' }}</small>
          </div>
        </div>
      </div>

      <div class="audit-score-strip">
        <div class="audit-score-item">
          <span>Status</span>
          <strong class="audit-status-pill" [attr.data-status]="status">
            {{ formatStatus(status) }}
          </strong>
        </div>

        <div class="audit-score-item">
          <span>Progress</span>
          <strong>{{ progress.reviewed }}/{{ progress.total }}</strong>
        </div>

        <div class="audit-score-progress">
          <div class="audit-progress-track">
            <span [style.width.%]="progress.total ? (progress.reviewed / progress.total) * 100 : 0"></span>
          </div>
          <small>
            {{ progress.passed }} passed ·
            {{ progress.failed }} failed ·
            {{ progress.notApplicable }} N/A
          </small>
        </div>

        <div class="audit-score-item">
          <span>Score</span>
          <strong>{{ score === null ? '-' : (score + '%') }}</strong>
        </div>

        <div class="audit-score-item">
          <span>Passing</span>
          <strong>{{ passingScore }}%</strong>
        </div>

        <div class="audit-score-item">
          <span>Auto Failure</span>
          <strong [class.audit-auto-fail-text]="automaticFailure">
            {{ automaticFailure ? 'Triggered' : 'No' }}
          </strong>
        </div>
      </div>

      <div class="audit-review-metadata-card">
        <div class="audit-metadata-heading">
          <div><strong>Audit Validation Details</strong><span>Specify the audit scope and verification evidence.</span></div>
          <span *ngIf="metadataDirty" class="audit-metadata-dirty">Unsaved changes</span>
        </div>
        <div class="audit-metadata-grid">
          <div class="audit-metadata-field">
            <label>Audit Type</label>
            <div class="audit-metadata-options">
              <label *ngFor="let option of auditTypeOptions">
                <input type="checkbox" [checked]="auditTypes.includes(option)"
                  [disabled]="!canEdit || saving || workflowLoading"
                  (change)="toggleAuditType(option, typeCheck.checked)" #typeCheck>
                {{ option === 'BOTH' ? 'Both' : (option === 'PMS' ? 'PMS' : 'Breakdown') }}
              </label>
            </div>
          </div>
          <div class="audit-metadata-field">
            <label>Source of Validation</label>
            <div class="audit-metadata-options">
              <label *ngFor="let option of validationSourceOptions">
                <input type="checkbox" [checked]="validationSources.includes(option)"
                  [disabled]="!canEdit || saving || workflowLoading"
                  (change)="toggleValidationSource(option, sourceCheck.checked)" #sourceCheck>
                {{ option === 'CALLER_ID' ? 'Caller ID' : (option === 'FAXBACK' ? 'Faxback' : 'Web') }}
              </label>
            </div>
          </div>
          <div class="audit-metadata-field audit-metadata-faxback">
            <label>Attach Document</label>
            <label class="audit-faxback-upload" *ngIf="canEdit">
              <i class="fa-solid fa-paperclip"></i> {{ selectedFaxback ? 'Replace selected file' : 'Attach Faxback' }}
              <input type="file" accept=".pdf,.png,.jpg,.jpeg,.tif,.tiff"
                [disabled]="saving || workflowLoading" (change)="chooseFaxback($event)">
            </label>
            <span class="audit-faxback-selected" *ngIf="selectedFaxback">
              {{ selectedFaxback.name }}
              <button type="button" [disabled]="saving || workflowLoading"
                (click)="clearSelectedFaxback()" title="Cancel selected upload">×</button>
            </span>
            <a *ngIf="faxbackDocument" class="audit-faxback-link" href="javascript:void(0)"
              (click)="openFaxback()" [attr.aria-disabled]="viewingFaxback">
              <i class="fa-solid fa-file-lines"></i>
              {{ faxbackDocument.fileName || 'View saved Faxback' }}
            </a>
            <small *ngIf="!faxbackDocument && !selectedFaxback">No Faxback document attached.</small>
          </div>
        </div>
      </div>

      <div class="audit-auto-failure-banner" *ngIf="automaticFailure">
        <div class="audit-auto-failure-icon">
          <i class="fa-solid fa-triangle-exclamation"></i>
        </div>
        <div>
          <strong>Automatic Failure Triggered</strong>
          <div *ngIf="automaticFailureDetails.length; else genericAutoFailure">
            <span *ngFor="let item of automaticFailureDetails; let last = last">
              {{ item.severity }}
              <ng-container *ngIf="item.count !== null && item.limit !== null">
                has reached its configured threshold ({{ item.count }} / {{ item.limit }})
              </ng-container>
              <ng-container *ngIf="item.count === null || item.limit === null">
                has triggered automatic audit failure
              </ng-container>{{ last ? '.' : '; ' }}
            </span>
          </div>
          <ng-template #genericAutoFailure>
            <span>A configured severity threshold has been reached. This audit cannot be passed.</span>
          </ng-template>
        </div>
      </div>

      <div class="audit-review-card">
        <div class="audit-section-tabs">
          <button
            *ngFor="let section of sections"
            type="button"
            [class.active]="activeSection === section"
            (click)="selectSection(section)">
            {{ sectionLabels[section] || section }}
          </button>
        </div>

        <div class="audit-review-workspace">
          <div class="audit-question-list-panel">
            <div class="audit-panel-heading">
              <div>
                <strong>Audit Questions</strong>
                <span>{{ visibleQuestions.length }} questions</span>
              </div>
            </div>

            <div class="audit-question-list">
              <button
                *ngFor="let question of visibleQuestions; trackBy: trackQuestion"
                type="button"
                class="audit-question-row"
                [class.active]="selectedQuestion?.question_id === question.question_id"
                [class.question-failed]="question.draftStatus === 'FAIL'"
                [class.question-passed]="question.draftStatus === 'PASS'"
                [class.question-na]="question.draftStatus === 'NOT_APPLICABLE'"
                (click)="selectQuestion(question)">
                <div class="audit-question-sequence">{{ question.sequence }}</div>

                <div class="audit-question-copy">
                  <strong>{{ question.question }}</strong>
                  <span>
                    {{ getAnswerSummary(question) === '-' ? 'No captured answer' : getAnswerSummary(question) }}
                  </span>
                </div>

                <div class="audit-question-state">
                  {{ question.draftStatus === 'PENDING' ? 'Pending' : formatStatus(question.draftStatus) }}
                </div>
              </button>

              <div class="audit-empty-state" *ngIf="visibleQuestions.length === 0">
                No audit questions are available for this section.
              </div>
            </div>
          </div>

          <div class="audit-question-review-panel" *ngIf="selectedQuestion; else noQuestionSelected">
            <div class="audit-panel-heading">
              <div>
                <strong>Question Review</strong>
                <span>{{ sectionLabel }}</span>
              </div>

              <span class="severity-readonly" [attr.data-severity]="selectedQuestion.severity">
                {{ selectedQuestion.severity || '-' }}
              </span>
            </div>

            <div class="audit-observed-card">
              <div>
                <span>Question</span>
                <strong>{{ selectedQuestion.question }}</strong>
              </div>
              <div>
                <span>Observed Answer</span>

                <strong *ngIf="observedAnswerFields.length <= 1">
                  {{ observedAnswer }}
                </strong>

                <div
                  *ngIf="observedAnswerFields.length > 1"
                  class="audit-observed-answer-grid">
                  <div
                    *ngFor="let field of observedAnswerFields"
                    class="audit-observed-answer-item">
                    <span>{{ field.label }}</span>
                    <strong>{{ field.value }}</strong>
                  </div>
                </div>
              </div>
            </div>

            <div class="audit-readonly-meta severity-policy-meta">
              <div>
                <span>Category</span>
                <strong>{{ selectedQuestion.category_type }}</strong>
              </div>
              <div>
                <span>Deduction</span>
                <strong>{{ formatDeduction(selectedQuestion.deduction_percent) }}</strong>
              </div>
              <div>
                <span>Auto-Fail Threshold</span>
                <strong>{{ formatFailureThreshold(selectedQuestion.failure_count) }}</strong>
              </div>
              <div>
                <span>Category Weight</span>
                <strong>{{ selectedQuestion.category_weight }}</strong>
              </div>
              <!-- <div>
                <span>Question Weight</span>
                <strong>{{ selectedQuestion.question_weight }}</strong>
              </div> -->
            </div>

            <div class="audit-review-field">
              <label>Review Decision <span>*</span></label>
              <div class="audit-decision-grid">
                <button
                  type="button"
                  [class.active-pass]="selectedQuestion.draftStatus === 'PASS'"
                  [disabled]="!canEdit"
                  (click)="markQuestionStatus(selectedQuestion, 'PASS')">
                  <i class="fa-solid fa-check"></i>
                  Pass
                </button>

                <button
                  type="button"
                  [class.active-fail]="selectedQuestion.draftStatus === 'FAIL'"
                  [disabled]="!canEdit"
                  (click)="markQuestionStatus(selectedQuestion, 'FAIL')">
                  <i class="fa-solid fa-xmark"></i>
                  Fail
                </button>

                <button
                  type="button"
                  [class.active-na]="selectedQuestion.draftStatus === 'NOT_APPLICABLE'"
                  [disabled]="!canEdit"
                  (click)="markQuestionStatus(selectedQuestion, 'NOT_APPLICABLE')">
                  <i class="fa-solid fa-minus"></i>
                  Not Applicable
                </button>
              </div>
            </div>

            <div class="audit-editor-grid" *ngIf="selectedQuestion.draftStatus === 'FAIL'">
              <div class="audit-review-field">
                <label>Error Category</label>
                <div class="audit-frozen-mapping">{{ selectedQuestion.error_category || '-' }}</div>
              </div>

              <div class="audit-review-field">
                <label>Error Type</label>
                <div class="audit-frozen-mapping">{{ selectedQuestion.error_type || '-' }}</div>
              </div>

              <div class="audit-review-field">
                <label>Expected Value</label>
                <input
                  [(ngModel)]="selectedQuestion.draftExpectedValue"
                  (ngModelChange)="updateQuestionDraft(selectedQuestion)"
                  [disabled]="!canEdit"
                  maxlength="2000"
                  placeholder="Expected/correct value">
              </div>

              <div class="audit-review-field" *ngIf="selectedQuestion.other_error_detail_required">
                <label>Other Error Detail <span>*</span></label>
                <input
                  [(ngModel)]="selectedQuestion.draftOtherErrorDetail"
                  (ngModelChange)="updateQuestionDraft(selectedQuestion)"
                  [disabled]="!canEdit"
                  maxlength="500"
                  placeholder="e.g. Formatting Issue">
                <small>Required because the pre-mapped Error Type is OTHERS.</small>
              </div>
            </div>

            <div class="audit-review-field audit-remark-field">
              <label>
                Auditor Remark
                <span
                  *ngIf="selectedQuestion.draftStatus === 'FAIL' || selectedQuestion.draftStatus === 'NOT_APPLICABLE'">
                  *
                </span>
                <small
                  *ngIf="selectedQuestion.draftStatus === 'PASS'"
                  class="audit-optional-label">
                  Optional
                </small>
              </label>
              <textarea
                [(ngModel)]="selectedQuestion.draftRemark"
                (ngModelChange)="updateQuestionDraft(selectedQuestion)"
                [disabled]="!canEdit"
                maxlength="2000"
                rows="4"
                placeholder="Add auditor remarks or review notes"></textarea>
              <small>{{ selectedQuestion.draftRemark.length }}/2000</small>
            </div>

            <div class="audit-question-footer">
              <span *ngIf="selectedQuestion.dirty">
                <i class="fa-solid fa-circle"></i>
                Unsaved change
              </span>
              <span *ngIf="!selectedQuestion.dirty && selectedQuestion.review_status !== 'PENDING'">
                Reviewed
                <ng-container *ngIf="selectedQuestion.reviewed_at">
                  · {{ selectedQuestion.reviewed_at | date:'MM/dd/yyyy hh:mm a':'UTC' }}
                </ng-container>
              </span>
            </div>
          </div>

          <ng-template #noQuestionSelected>
            <div class="audit-question-review-panel audit-empty-panel">
              Select a question to review.
            </div>
          </ng-template>
        </div>
      </div>

      <div class="audit-findings-card">
        <div class="audit-findings-header">
          <div>
            <h3>Logged Audit Findings ({{ findings.length }})</h3>
            <p>Failed questions create findings automatically.</p>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table table-sm audit-findings-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Question</th>
                <th>Section</th>
                <th>Error Type</th>
                <th>Severity</th>
                <th>Weight</th>
                <th>Observed</th>
                <!-- <th>Expected</th> -->
                <th>Remark</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let finding of findings; let i = index">
                <td>{{ i + 1 }}</td>
                <td>
                  {{ getQuestionName(finding.question_id) }}
                </td>
                <td>{{ sectionLabels[finding.section] || finding.section || '-' }}</td>
                <td>{{ formatErrorType(finding.error_type) }}</td>
                <td>
                  <span class="finding-severity" [attr.data-severity]="finding.severity">
                    {{ finding.severity || '-' }}
                  </span>
                </td>
                <td>{{ displayValue(finding.question_weight) }}</td>
                <td>{{ displayValue(finding.observed_value) }}</td>
                <!-- <td>{{ displayValue(finding.expected_value) }}</td> -->
                <td class="finding-remark">{{ finding.remark || '-' }}</td>
                <td>
                  <div class="finding-actions" *ngIf="canEdit">
                    <button type="button" class="finding-edit" (click)="editFinding(finding)" title="Edit finding">
                      <i class="fa-solid fa-pen"></i>
                    </button>
                    <button type="button" class="finding-delete" (click)="resolveFinding(finding)" title="Resolve finding">
                      <i class="fa-regular fa-trash-can"></i>
                    </button>
                  </div>
                </td>
              </tr>

              <tr *ngIf="findings.length === 0">
                <td colspan="10" class="audit-empty-row">
                  No audit findings have been logged.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="audit-review-footer">
        <button type="button" class="audit-back-btn" (click)="goBack()">
          Back
        </button>

        <div class="audit-review-footer-actions" *ngIf="canEdit">
          <button
            type="button"
            class="audit-save-btn"
            (click)="saveAudit()"
            [disabled]="saving || workflowLoading">
            <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
            Save Audit
          </button>

          <button
            type="button"
            class="audit-changes-btn"
            (click)="requestChanges()"
            [disabled]="!canRequestChanges">
            Request Changes
          </button>

          <button
            type="button"
            class="audit-pass-btn"
            (click)="passAudit()"
            [disabled]="!canPassAudit">
            Pass Audit
          </button>
        </div>
      </div>

      <div class="audit-side-drawer" *ngIf="timeline.length || revisions.length">
        <div class="audit-drawer-section" *ngIf="timeline.length">
          <h4>Audit Activity</h4>
          <div class="audit-timeline-row" *ngFor="let item of timeline">
            <span class="timeline-dot"></span>
            <div>
              <strong>{{ formatStatus(item.event_type) }}</strong>
              <span>{{ item.event_time | date:'MM/dd/yyyy hh:mm a':'UTC' }}</span>
            </div>
          </div>
        </div>

        <div class="audit-drawer-section" *ngIf="revisions.length">
          <h4>Revisions</h4>
          <div class="audit-revision-row" *ngFor="let revision of revisions">
            <strong>Revision {{ revision.revision_number }}</strong>
            <span>{{ formatStatus(revision.status) }}</span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
